import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"

const InviteSmsForm = ({
  initialValues,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  submitForm,
  setFieldValue,
  setFieldTouched,
}) => {

  return (
    <React.Fragment>
      <Form className="form-horizontal" id="sms-form">
      <Row>
          <Input
                type="hidden"
                id="url_identifier"
                name="url_identifier"
                value={values.url_identifier || ""}
                invalid={errors.url_identifier ? true : false}
              />
              {touched.url_identifier && errors.url_identifier ? (
                <FormFeedback
                  className="mb-3"
                  type="invalid"
                  style={{ fontSize: "100%" }}
                >
                  {errors.url_identifier}
                </FormFeedback>
              ) : null}
          <Col lg="6">           
            <FormGroup className="mb-3">
              <Label htmlFor="firstname">First name</Label>
              <Input
                type="text"
                className="form-control"
                id="firstname"
                placeholder="First Name"
                onChange={handleChange}
                value={values.firstname || ""}
                invalid={
                  touched.firstname && errors.firstname ? true : false
                }
              />
              {touched.firstname && errors.firstname ? (
                <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                  {errors.firstname}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="lastname">Last Name</Label>
              <Input
                type="text"
                className="form-control"
                id="lastname"
                placeholder="Last Name"
                onChange={handleChange}
                value={values.lastname || ""}
                invalid={
                  touched.lastname && errors.lastname ? true : false
                }
              />
              {touched.lastname && errors.lastname ? (
                <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                  {errors.lastname}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
          </Row>
        <Row>
          <Col lg="12">            
            <FormGroup className="mb-3">
              <Label htmlFor="cellphone">Cell Phone</Label>
              <Input
                type="text"
                className="form-control"
                id="cellphone"
                placeholder="Cell Phone"
                onChange={handleChange}
                value={values.cellphone || ""}
                invalid={
                  touched.cellphone && errors.cellphone ? true : false
                }
              />
              {touched.cellphone && errors.cellphone ? (
                <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                  {errors.cellphone}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
          </Row>
      </Form>
    </React.Fragment>
  )
}

export default InviteSmsForm
